import { ShieldAlert, AlertCircle } from "lucide-react";

export function NsfwOrError({ message }: { message?: string }) {
  const isNsfw = message?.includes("acceptable use policy") || message?.includes("NSFW");

  if (isNsfw) {
    return (
      <div className="flex items-start gap-3 text-[13px] bg-red-50/80 border-2 border-red-300/60 rounded-xl px-4 py-3">
        <ShieldAlert className="size-5 text-red-500 shrink-0 mt-0.5" />
        <div>
          <p className="font-bold text-red-700 mb-0.5">Content not allowed</p>
          <p className="text-red-600/80 text-[12px] leading-relaxed">
            Your prompt was flagged by our content filter. AnimePup does not allow NSFW, violent, hateful, or otherwise prohibited content. Please revise your prompt and try again.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs text-red-400">
      <AlertCircle className="size-3.5 shrink-0" />
      {message || "Something went wrong. Please try again."}
    </div>
  );
}
